<template>
  <vbt-content-box
    :no-content="!roles.length"
    title="Roles"
    v-bind="$attrs"
  >
    <vbt-table
      :headers="headers"
      :items="roles"
      :page-size="5"
      searchable
      show-paginator
      show-remove-action
      @click:remove="removeRole"
    />
  </vbt-content-box>
</template>

<script>
import { wrapToLoadingFn } from '@helpers';

import UsersApiService from '../_services/users.api.service';

const headers = Object.freeze([
  { text: 'Role', value: 'role' },
  { text: 'Service', value: 'service' },
  { text: 'Location', value: 'location' },
]);

export default {
  name: 'UmsUserRolesList',
  props: {
    email: {
      type: String,
      default: '',
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  methods: {
    wrapToLoadingFn,
    removeRole({ role, service, location }) {
      this.$VBlackerTheme.alert.warning({
        text: `Remove role ${role}?`,
      }, () => this.wrapToLoadingFn({
        req: UsersApiService.removeUserRole.bind({}, {
          role,
          service,
          location,
          email: this.email,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('User role successfully removed');
          this.$emit('change:success');
        },
      }));
    },
  },
};
</script>
